import { DATE_TIME_PICKER_INPUT_HEIGHT } from '../../../../../../components/baseV2/fDateTimePicker/constants';
import { FORTA_BLUE, FORTA_ERROR } from '../../../../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';
import type { CSSProperties } from 'react';

export const AGREEMENT_SIGNATURE_TEXT_FIELD_SX: SxProps<Theme> = {
  '& .MuiInputLabel-root': {
    display: 'none',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: FORTA_BLUE.light3,
    borderRadius: 0,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderBottom: `1px solid ${FORTA_BLUE.primary}`,
    borderRadius: 0,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderBottom: `1px solid ${FORTA_BLUE.primary}`,
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderBottom: `1px solid ${FORTA_BLUE.primary}`,
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderBottom: `1px solid ${FORTA_BLUE.primary}`,
  },
  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderBottom: `1px solid ${FORTA_ERROR}`,
  },
};

export const AGREEMENT_SIGNATURE_DATE_PICKER_STYLE: CSSProperties = {
  width: '100%',
  height: DATE_TIME_PICKER_INPUT_HEIGHT,
  backgroundColor: FORTA_BLUE.light3,
  borderRadius: 0,
  border: 'none',
  borderBottom: `1px solid ${FORTA_BLUE.primary}`,
  boxShadow: 'none',
};

export const AGREEMENT_SIGNATURE_DATE_FIELD_SX: SxProps<Theme> = {
  '& .ant-picker:hover, & .ant-picker-focused': {
    border: 'none',
    borderBottom: `1px solid ${FORTA_BLUE.primary}`,
    boxShadow: 'none',
  },
};
